/* Tropical 1.0 — JS del tema. Sin librerías. Carga con defer. */
(function () {
  'use strict';
  var tt = window.tt || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Dinero ---------- */
  function dinero(centavos) {
    var fmt = tt.dinero || 'RD$ {{amount}}';
    var n = (centavos / 100).toFixed(2);
    var partes = n.split('.');
    var miles = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator)\s*\}\}/, function (m, t) {
      if (t === 'amount_no_decimals') return miles;
      if (t === 'amount_with_comma_separator') return partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + partes[1];
      return miles + '.' + partes[1];
    });
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function img(url, w) {
    if (!url) return '';
    return url.replace(/(\.[a-z]+)(\?|$)/i, '$1$2').replace(/(\?.*)?$/, function (q) { return (q ? q + '&' : '?') + 'width=' + w; });
  }
  function medir(nombre) { try { if (typeof window.clarity === 'function') window.clarity('event', nombre); } catch (e) {} }

  /* ---------- Cajones (menú, carrito) y buscador ---------- */
  var abierto = null;
  function abrir(id) {
    var el = document.getElementById(id); if (!el) return;
    if (abierto && abierto !== el) cerrar(abierto.id);
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('abierto'); });
    abierto = el;
    if (el.classList.contains('cajon')) document.documentElement.classList.add('sin-scroll');
    var foco = el.querySelector('input, button, a'); if (foco && id === 'buscador') foco.focus();
  }
  function cerrar(id) {
    var el = document.getElementById(id); if (!el) return;
    el.classList.remove('abierto');
    document.documentElement.classList.remove('sin-scroll');
    setTimeout(function () { if (!el.classList.contains('abierto')) el.hidden = true; }, 250);
    if (abierto === el) abierto = null;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-abrir]'); if (a) { e.preventDefault(); abrir(a.getAttribute('data-abrir')); return; }
    var c = e.target.closest('[data-cerrar]'); if (c) { e.preventDefault(); cerrar(c.getAttribute('data-cerrar')); return; }
    var ac = e.target.closest('[data-abrir-carrito]');
    if (ac && tt.cajonCarrito && !document.body.classList.contains('tpl-cart')) { e.preventDefault(); refrescar().then(function () { abrir('carrito'); }); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && abierto) cerrar(abierto.id); });

  /* ---------- Encabezado fijo: sombra al desplazar ---------- */
  var hdr = $('[data-hdr]');
  if (hdr) {
    var marca = false;
    window.addEventListener('scroll', function () {
      var s = window.scrollY > 4;
      if (s !== marca) { marca = s; hdr.classList.toggle('hdr--sombra', s); }
    }, { passive: true });
  }

  /* ---------- Carrito ---------- */
  function json(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}))
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }
  function pintar(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    $$('[data-cart-count-txt]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
    var lista = $('[data-cart-items]'); if (!lista) return cart;
    lista.innerHTML = cart.items.map(function (it) {
      var variante = it.product_has_only_default_variant ? '' : '<span class="ci__var">' + esc(it.variant_title) + '</span>';
      var descuentos = (it.line_level_discount_allocations || []).map(function (d) { return '<span class="ci__desc">' + esc(d.discount_application.title) + '</span>'; }).join('');
      return '<li class="ci" data-key="' + it.key + '">' +
        '<a class="ci__img" href="' + it.url + '">' + (it.image ? '<img src="' + img(it.image, 160) + '" alt="" width="72" height="72" loading="lazy">' : '') + '</a>' +
        '<div class="ci__info"><a class="ci__titulo" href="' + it.url + '">' + esc(it.product_title) + '</a>' + variante + descuentos +
        '<div class="ci__fila"><div class="cant-btns">' +
        '<button type="button" aria-label="Quitar uno" data-cant="' + (it.quantity - 1) + '">−</button><span>' + it.quantity + '</span>' +
        '<button type="button" aria-label="Agregar uno" data-cant="' + (it.quantity + 1) + '">+</button></div>' +
        '<strong>' + dinero(it.final_line_price) + '</strong></div></div></li>';
    }).join('');
    var vacio = $('[data-cart-vacio]'); if (vacio) vacio.hidden = cart.item_count > 0;
    var pie = $('[data-cart-pie]'); if (pie) pie.hidden = cart.item_count === 0;
    var total = $('[data-cart-total]'); if (total) total.textContent = dinero(cart.total_price);
    complementos(cart, $('[data-carrito] [data-complementos]'));
    return cart;
  }
  function refrescar() { return json(tt.rutas.cart + '.js').then(pintar); }
  function agregar(id, cantidad) {
    return json(tt.rutas.cartAdd + '.js', { method: 'POST', body: JSON.stringify({ items: [{ id: Number(id), quantity: cantidad || 1 }] }) })
      .then(refrescar);
  }
  function cambiar(key, cantidad) {
    return json(tt.rutas.cartChange + '.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: cantidad }) }).then(pintar);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-agregar]');
    if (b) {
      e.preventDefault();
      b.disabled = true; var txt = b.textContent; b.textContent = 'Agregando…';
      medir('tt_agregar');
      agregar(b.getAttribute('data-agregar'), 1).then(function () {
        b.textContent = '✓ Agregado';
        if (tt.cajonCarrito) abrir('carrito');
        setTimeout(function () { b.textContent = txt; b.disabled = false; }, 1600);
      }).catch(function (err) {
        b.textContent = (err && err.description) || 'No se pudo agregar'; setTimeout(function () { b.textContent = txt; b.disabled = false; }, 2200);
      });
      return;
    }
    var q = e.target.closest('.ci [data-cant]');
    if (q) { e.preventDefault(); cambiar(q.closest('.ci').getAttribute('data-key'), Number(q.getAttribute('data-cant'))); }
  });

  /* ---------- Complementa tu pedido ---------- */
  var cacheComp = {};
  function complementos(cart, caja) {
    if (!caja || !cart.items.length) { if (caja) caja.hidden = true; return; }
    var base = cart.items[0].product_id;
    var enCarrito = cart.items.map(function (i) { return i.product_id; });
    var pedir = cacheComp[base] ? Promise.resolve(cacheComp[base]) :
      json(tt.rutas.recomendaciones + '.json?product_id=' + base + '&limit=6&intent=complementary')
        .then(function (d) { return (d.products && d.products.length) ? d : json(tt.rutas.recomendaciones + '.json?product_id=' + base + '&limit=6'); })
        .then(function (d) { cacheComp[base] = d; return d; });
    pedir.then(function (d) {
      var ps = (d.products || []).filter(function (p) { return enCarrito.indexOf(p.id) < 0 && p.available && p.variants && p.variants.length === 1; }).slice(0, 3);
      var lista = caja.querySelector('[data-complementos-lista]');
      lista.innerHTML = ps.map(function (p) {
        return '<li class="comp"><a class="comp__img" href="' + p.url + '">' + (p.featured_image ? '<img src="' + img(p.featured_image, 160) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</a>' +
          '<div class="comp__info"><a href="' + p.url + '">' + esc(p.title) + '</a><span>' + dinero(p.price) + '</span></div>' +
          '<button class="btn btn--mini" type="button" data-agregar="' + p.variants[0].id + '">Agregar</button></li>';
      }).join('');
      caja.hidden = ps.length === 0;
    }).catch(function () { caja.hidden = true; });
  }
  var compPagina = $('.complementos--pagina');
  if (compPagina) refrescar().then(function (c) { complementos(c, compPagina); });

  /* ---------- Búsqueda predictiva ---------- */
  var q = $('[data-busqueda]'), res = $('[data-busqueda-res]'), t;
  if (q && res) {
    q.addEventListener('input', function () {
      clearTimeout(t);
      var v = q.value.trim();
      if (v.length < 2) { res.innerHTML = ''; return; }
      t = setTimeout(function () {
        json(tt.rutas.busqueda + '.json?q=' + encodeURIComponent(v) + '&resources[type]=product&resources[limit]=6').then(function (d) {
          var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          res.innerHTML = ps.length ? '<ul class="pred">' + ps.map(function (p) {
            return '<li><a href="' + p.url + '">' + (p.image ? '<img src="' + img(p.image, 120) + '" alt="" width="48" height="48" loading="lazy">' : '') +
              '<span>' + esc(p.title) + '</span><strong>' + esc(p.price) + '</strong></a></li>';
          }).join('') + '</ul>' : '<p class="pred__nada">Sin resultados para “' + esc(v) + '”.</p>';
        }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- Galería simple (scroll-snap) ---------- */
  $$('[data-galeria]').forEach(function (g) {
    var pista = g.querySelector('[data-galeria-pista]'); if (!pista) return;
    var puntos = $$('[data-galeria-punto]', g), minis = $$('[data-galeria-mini]', g);
    function ir(i) { var s = pista.children[i]; if (s) pista.scrollTo({ left: s.offsetLeft - pista.offsetLeft, behavior: 'smooth' }); }
    function marcar() {
      var i = Math.round(pista.scrollLeft / pista.clientWidth);
      puntos.forEach(function (p, k) { p.classList.toggle('activo', k === i); });
      minis.forEach(function (m, k) { m.classList.toggle('activo', k === i); });
    }
    puntos.concat(minis).forEach(function (b) { b.addEventListener('click', function () { ir(Number(b.getAttribute('data-i'))); }); });
    pista.addEventListener('scroll', function () { window.requestAnimationFrame(marcar); }, { passive: true });
  });

  /* ---------- Página del carrito: abrir Releasit al llegar con ?pedir=1 ---------- */
  if (document.body.classList.contains('tpl-cart') && /[?&]pedir=1/.test(location.search)) {
    var intentos = 0;
    var abrirRsi = setInterval(function () {
      var b = $$('._rsi-buy-now-button').filter(function (x) { return !x.classList.contains('_rsi-modal-submit-button') && x.offsetHeight > 0; })[0];
      if (b) { clearInterval(abrirRsi); medir('tt_pedir_carrito'); b.click(); }
      else if (++intentos > 40) clearInterval(abrirRsi);
    }, 150);
  }
  document.addEventListener('click', function (e) { if (e.target.closest('[data-pedir]')) medir('tt_pedir_cajon'); });

  /* ---------- Variantes en la ficha ---------- */
  $$('[data-variantes]').forEach(function (box) {
    var ficha = box.closest('[data-ficha]'); if (!ficha) return;
    var variantes = []; try { variantes = JSON.parse(box.querySelector('[data-variantes-json]').textContent); } catch (e) { return; }
    box.addEventListener('change', function () {
      var elegidas = $$('input[data-opcion]:checked', box).map(function (i) { return i.value; });
      var v = variantes.filter(function (x) { return x.options.every(function (o, k) { return o === elegidas[k]; }); })[0];
      if (!v) return;
      $$('[data-variante-id]', ficha).forEach(function (i) { i.value = v.id; i.dispatchEvent(new Event('change', { bubbles: true })); });
      var b = $('[data-agregar-ficha]', ficha); if (b) { b.disabled = !v.available; b.textContent = v.available ? 'Agregar al pedido' : 'Agotado'; }
      var act = $('[data-precio-actual]', ficha); if (act) act.textContent = dinero(v.price);
      var ant = $('[data-precio-antes]', ficha); if (ant) ant.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : '';
      var ah = $('[data-precio-ahorra]', ficha); if (ah && v.compare_at_price > v.price) ah.textContent = dinero(v.compare_at_price - v.price);
      var pc = $('[data-precio-pct]', ficha); if (pc && v.compare_at_price > v.price) pc.textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
      if (v.featured_media) {
        var pista = $('[data-galeria-pista]', ficha), idx = -1;
        $$('img', pista).forEach(function (im, k) { if (idx < 0 && v.featured_media.preview_image && im.src.indexOf(v.featured_media.preview_image.src.split('?')[0].split('/').pop()) > -1) idx = k; });
        if (idx > -1) pista.scrollTo({ left: pista.children[idx].offsetLeft - pista.offsetLeft, behavior: 'smooth' });
      }
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
    });
  });

  /* ---------- Compra por necesidad: pestañas ---------- */
  $$('[data-necesidades]').forEach(function (sec) {
    var tabs = $$('[data-nec-tab]', sec), panels = $$('[data-nec-panel]', sec);
    function ver(id, desplazar) {
      var ok = tabs.some(function (t) { return t.getAttribute('data-nec-tab') === id; }); if (!ok) return;
      tabs.forEach(function (t) { var a = t.getAttribute('data-nec-tab') === id; t.classList.toggle('activo', a); t.setAttribute('aria-selected', a); if (a) t.scrollIntoView({ block: 'nearest', inline: 'center' }); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-nec-panel') !== id; });
      medir('tt_necesidad_' + id);
      if (desplazar) sec.scrollIntoView({ behavior: 'smooth' });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { ver(t.getAttribute('data-nec-tab')); }); });
    var n = new URLSearchParams(location.search).get('n'); if (n) ver(n, true);
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="n="]'); if (!a) return;
      var u = new URL(a.href, location.href); if (u.pathname !== location.pathname || !u.searchParams.get('n')) return;
      e.preventDefault(); ver(u.searchParams.get('n'), true);
      var m = document.getElementById('menu-movil'); if (m && !m.hidden) cerrar('menu-movil');
    });
  });

  tt.carrito = { refrescar: refrescar, agregar: agregar, abrir: function () { abrir('carrito'); } };
  window.tt = tt;
})();
